import { Dropdown } from "antd-mobile";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { FilterDrawer } from "../FilterWithQuickSearch/components";
import { FilterDrawerMultiDropdown } from "./components";
import styles from "./style.module.scss";
import "./style.scss";

const FilterMultiDropdown = ({
  customDropdownStyleClass = "",
  customDropDownContainerStyleClass = "",
  filterSetup = {},
  localFilterValue = {},
  filterDefaultValue = {},
  setLocalFilterValue = () => {},
  apiValue = {},
  onReset = () => {},
  onSubmitSearch = () => {},
  setDependency = () => {},
  customDropdownTitle = {},
  dependency = {},
  activeTab = "",
}) => {
  const { t } = useTranslation();
  const { filters } = filterSetup;
  const dropDownRef = useRef();

  const handleOnReset = () => {
    setLocalFilterValue(filterDefaultValue);
    onReset();
  };

  const handleOnSubmitSearch = () => {
    dropDownRef.current.close();
    onSubmitSearch();
  };

  const renderFilterDrawer = (filter) => {
    switch (filter.data_type) {
      case "grouped":
        return (
          <FilterDrawer
            filters={filter.items}
            localFilterValue={localFilterValue}
            setLocalFilterValue={setLocalFilterValue}
            setDependency={setDependency}
            dependency={dependency}
            onReset={handleOnReset}
            onSubmitSearch={handleOnSubmitSearch}
            apiValue={apiValue}
          />
        );

      case "static":
        return (
          <FilterDrawerMultiDropdown
            filters={filter}
            localFilterValue={localFilterValue}
            setLocalFilterValue={setLocalFilterValue}
            onReset={handleOnReset}
            onSubmitSearch={handleOnSubmitSearch}
          />
        );
      case "api":
        return (
          <FilterDrawerMultiDropdown
            filters={{
              ...filter,
              value_enum: apiValue[filter.data_index].value_enum,
              default_value: apiValue[filter.data_index].default_value || null,
            }}
            localFilterValue={localFilterValue}
            setLocalFilterValue={setLocalFilterValue}
            onReset={handleOnReset}
            onSubmitSearch={handleOnSubmitSearch}
          />
        );
      default:
        return (
          <FilterDrawerMultiDropdown
            filters={filter}
            localFilterValue={localFilterValue}
            setLocalFilterValue={setLocalFilterValue}
            onReset={handleOnReset}
            onSubmitSearch={handleOnSubmitSearch}
          />
        );
    }
  };

  //close dropdown when tabs being changed
  useEffect(() => {
    dropDownRef.current.close();
  }, [activeTab]);
  return (
    <div
      className={`${styles.container} ${customDropDownContainerStyleClass} multi-dropdown-filter-container`}
    >
      <Dropdown ref={dropDownRef}>
        {filters.map((filter) => (
          <Dropdown.Item
            key={filter.data_index}
            className={`${"custom-dropdown"} ${customDropdownStyleClass}`}
            title={
              customDropdownTitle[filter.title]
                ? customDropdownTitle[filter.title]
                : t(filter.title)
            }
          >
            {renderFilterDrawer(filter)}
          </Dropdown.Item>
        ))}
      </Dropdown>
    </div>
  );
};

export default FilterMultiDropdown;
